<template>
    <div>

        <div v-if="!canAdd" class="margin-bottom">
            <a href="/billing/history" class="tool-tip">
                <div class="left">
                    <div class="headline">Maximum Children Reached</div>
                    <div>It looks like you’ve hit your ceiling of {{ children.length }}/{{ children.length }} children allowed. If you need to add more children, you’ll need to upgrade your account first by clicking here.</div>
                </div>
                <div class="right"><span class="fa fa-bullhorn"></span></div>
            </a>
        </div>

        <div class="general-title">
            <div class="title">Children</div>
            <div v-if="canAdd" class="buttons-container buttons">
                <a href="/settings/children/create" class="good-bg">Add A Child<span class="fa fa-plus"></span></a>
            </div>
        </div>

        <div class="list-container">
            <div class="table">
                <div v-if="children.length > 0" class="row">
                    <div class="cell"><a href="" class="point-up">Child<span class="fa fa-angles-down"></span></a></div>
                    <div class="cell align-center"><a href="" class="point-down">Age</a></div>
                    <div class="cell align-center"><a href="" class="point-down">Current Level</a></div>
                    <div class="cell align-right"></div>
                </div>
                <div v-for="child in children" :key="`child-${ child.id }`" class="row">
                    <div class="cell">{{ child.first_name }} {{ child.last_name }}</div>
                    <div class="cell align-center">{{ age(child) }} {{ age(child) !== 1 ? 'years' : 'year' }} old</div>
                    <div class="cell align-center"><span class="status-bubble" :class="levelClass(child.level)">{{ child.level }}</span></div>
                    <div class="cell align-right">
                        <div v-if="child.is_active" class="buttons">
                            <delete-button @deleted="toggleChildStatus(child)" icon="fa-arrow-down" text="Deactivate" confirm-text="Confirm Deactivate" deleting-text="Deactivating">
                                <a :href="`/settings/children/${ child.id }/edit`" class="neutral-bg">Update<span class="fa fa-wrench"></span></a>
                            </delete-button>
                        </div>
                        <div v-else class="buttons">
                            <a :href="`/settings/children/${ child.id }/edit`" class="neutral-bg">Update<span class="fa fa-wrench"></span></a>
                            <a href @click.prevent="toggleChildStatus(child)" class="good-bg">Activate<span class="fa fa-arrow-up"></span></a>
                        </div>
                    </div>
                </div>

                <nothing-here v-if="children.length === 0"></nothing-here>
            </div>
        </div>

    </div>
</template>

<script>

import ChildMixin from '@/mixins/ChildMixin';
import moment from 'moment';
import apiErrors from '@/utils/apiErrors';
import axios from 'axios';

export default {

    props: [ 'children', 'canAdd' ],

    mixins: [ ChildMixin ],

    methods: {

        age(child) {
            return moment().diff(moment(child.birthdate), 'years');
        },

        async toggleChildStatus(child) {
            try {
                await axios.post('/settings/children/toggle-status/' + child.id, { childId: child.id });
                window.location.reload();
            } catch (e) {
                this.$store.dispatch('setError', apiErrors.getErrorMessage(e));
            }

        }

    },

}

</script>



// WEBPACK FOOTER //
// resources/js/components/settings/children/ChildrenList.vue